export { PLUGIN_KEY, PLUGIN_PRIORITY, ColumnSummary } from "./columnSummary.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/columnSummary/index.mjs
// module id = 1276
// module chunks = 1